import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterSchemes',
    standalone: false
})
export class FilterSchemesPipe implements PipeTransform {
    transform(schemes: any, minColors: number): { [key: string]: string[] } {
      if (!schemes || !minColors) {
        return schemes;
      }
  
      return Object.keys(schemes)
        .filter((key) => schemes[key].length >= minColors)
        .reduce((filtered, key) => {
          filtered[key] = schemes[key];
          return filtered;
        }, {});
    }
  }
